import { render, staticRenderFns } from "./productcategory.vue?vue&type=template&id=5d22e226&scoped=true&"
import script from "./productcategory.vue?vue&type=script&lang=js&"
export * from "./productcategory.vue?vue&type=script&lang=js&"
import style0 from "./productcategory.vue?vue&type=style&index=0&id=5d22e226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22e226",
  null
  
)

export default component.exports